/**
 * P6: sales 申请创建客户弹框
 *
 * sales 点 /customers [申请新客户] 进入，填表 → 提交 → 主管 IM 审批
 */
import { useState } from 'react';
import { Modal, Input, Radio, message as antdMsg } from 'antd';
import { useMutation } from '@tanstack/react-query';
import { $ } from '../lib/api';
import { Btn } from './ui';

export function NewCustomerRequestModal({
  open, onClose, onDone,
}: {
  open: boolean;
  onClose: () => void;
  onDone: () => void;
}) {
  const [form, setForm] = useState({
    customer_name: '',
    wechat_nickname: '',
    phone: '',
    wechat_id: '',
    source: 'xiaohongshu',
    demand_type: '',
    reason: '',
  });

  const submit = useMutation({
    mutationFn: () => $.post('/customer-creation-requests', form),
    onSuccess: () => {
      antdMsg.success('申请已提交，等待主管审批');
      setForm({ customer_name: '', wechat_nickname: '', phone: '', wechat_id: '', source: 'xiaohongshu', demand_type: '', reason: '' });
      onDone();
    },
    onError: (e: any) => antdMsg.error(e?.message ?? '提交失败'),
  });

  const canSubmit = form.customer_name.trim() && (form.phone.trim() || form.wechat_id.trim());

  return (
    <Modal
      title="申请创建客户"
      open={open}
      onCancel={onClose}
      footer={
        <>
          <Btn kind="default" onClick={onClose}>取消</Btn>
          <Btn kind="primary" onClick={() => submit.mutate()} disabled={!canSubmit || submit.isPending}>
            {submit.isPending ? '提交中…' : '提交申请'}
          </Btn>
        </>
      }
      width={520}
    >
      <div style={{
        padding: 10, marginBottom: 16, background: 'var(--primary-bg)',
        borderRadius: 6, fontSize: 12, color: 'var(--text-2)',
      }}>
        💡 销售员自加客户需经主管审批。主管未在 24 小时内审批将自动通过。
      </div>

      <Row label="客户姓名 *">
        <Input autoFocus value={form.customer_name} onChange={(e) => setForm({ ...form, customer_name: e.target.value })} />
      </Row>
      <Row label="客户微信昵称">
        <Input value={form.wechat_nickname} onChange={(e) => setForm({ ...form, wechat_nickname: e.target.value })}
               placeholder="如：张momo" />
      </Row>
      <Row label="手机号">
        <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
      </Row>
      <Row label="微信号">
        <Input value={form.wechat_id} onChange={(e) => setForm({ ...form, wechat_id: e.target.value })}
               placeholder="手机号 / 微信号 至少填一项" />
      </Row>
      <Row label="客户来源">
        <Radio.Group value={form.source} onChange={(e) => setForm({ ...form, source: e.target.value })}>
          <Radio value="xiaohongshu">小红书</Radio>
          <Radio value="douyin">抖音</Radio>
          <Radio value="shipinhao">视频号</Radio>
          <Radio value="baidu">百度</Radio>
          <Radio value="other">其他</Radio>
        </Radio.Group>
      </Row>
      <Row label="客户需求类型">
        <Radio.Group value={form.demand_type} onChange={(e) => setForm({ ...form, demand_type: e.target.value })}>
          <Radio value="work_cert">🎯 工作考证</Radio>
          <Radio value="fulltime_shop">🏪 全职做店铺</Radio>
          <Radio value="sideline_shop">💰 副业做店铺</Radio>
          <Radio value="brand_overseas">🌍 品牌出海</Radio>
        </Radio.Group>
      </Row>
      <Row label="申请理由 / 备注">
        <Input.TextArea value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })}
                        rows={3} placeholder="解释为什么自己加微而非走投流（如：朋友介绍 / 老客户转介 / 等）" />
      </Row>
    </Modal>
  );
}

function Row({ label, children }: { label: string; children: any }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 12, color: 'var(--text-2)', marginBottom: 4 }}>{label}</div>
      {children}
    </div>
  );
}
